import * as userSettings from '../actions/userSettingsActions';

export default function userSettingsReducer(state = {}, action) {
    switch (action.type) {
        case userSettings.USER_SETTINGS_SAVE:
            return Object.assign({}, state, { [action.key]: (state[action.key] ? Object.assign({}, state[action.key], action.settings) : action.settings)});
        default:
            return state;
    }
}